import Button from '@ui-kit/components/Button';
import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';

const DirectPaymentSuccess = ({ closeModal }: ModalProps) => {
  const { t } = useTranslation(['Modal', 'Button']);

  return (
    <Modal title={t('DirectPaymentSuccess.title')}>
      <p>{t('DirectPaymentSuccess.info')}</p>
      <ModalActions>
        <Button onClick={closeModal}>{t('Button:clear')}</Button>
      </ModalActions>
    </Modal>
  );
};

export default DirectPaymentSuccess;
